"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var astrocite_core_1 = require("astrocite-core");
var he_1 = require("he");
var constants_1 = require("./constants");
var error_1 = require("./error");
var schema_1 = require("./schema");
var FIELD_TRANSFORMS = new Map([
    [
        'articleids',
        function (_a) {
            var e_1, _b, e_2, _c, e_3, _d;
            var articleids = _a.articleids, uid = _a.uid;
            var ids = {};
            try {
                for (var articleids_1 = __values(articleids), articleids_1_1 = articleids_1.next(); !articleids_1_1.done; articleids_1_1 = articleids_1.next()) {
                    var _e = articleids_1_1.value, idtype = _e.idtype, value = _e.value;
                    ids[idtype] = value;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (articleids_1_1 && !articleids_1_1.done && (_b = articleids_1.return)) _b.call(articleids_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var data = {};
            if (ids.doi) {
                data.DOI = ids.doi;
            }
            try {
                for (var _f = __values([ids.pubmed, ids.pmid]), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var value = _g.value;
                    if (value) {
                        data.PMID = value;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                }
                finally { if (e_2) throw e_2.error; }
            }
            try {
                for (var _h = __values([ids.pmc, ids.pmcid]), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var value = _j.value;
                    if (value && value.match(/^PMC\d+$/)) {
                        data.PMCID = value;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_d = _h.return)) _d.call(_h);
                }
                finally { if (e_3) throw e_3.error; }
            }
            if (data.PMID && data.PMID === uid) {
                data.URL = "https://www.ncbi.nlm.nih.gov/pubmed/" + data.PMID;
            }
            else if (data.PMCID && data.PMCID === "PMC" + uid) {
                data.URL = "https://www.ncbi.nlm.nih.gov/pmc/articles/" + data.PMCID;
            }
            return data;
        },
    ],
    [
        'authors',
        function (_a) {
            var authors = _a.authors;
            return {
                author: authors
                    .map(function (_a) {
                    var authtype = _a.authtype, name = _a.name;
                    switch (authtype) {
                        case 'CollectiveName':
                            if (!name) {
                                return undefined;
                            }
                            return {
                                literal: name,
                            };
                        case 'Author':
                        default:
                            var _b = __read(name.split(' '), 2), family = _b[0], given = _b[1];
                            if (!family) {
                                return undefined;
                            }
                            return __assign({ family: family }, (given ? { given: given } : {}));
                    }
                })
                    .filter(Boolean),
            };
        },
    ],
    [
        'lang',
        function (_a) {
            var lang = _a.lang;
            return {
                language: lang[0],
            };
        },
    ],
    [
        'sortdate',
        function (_a) {
            var sortdate = _a.sortdate;
            return {
                issued: astrocite_core_1.parseDate(sortdate),
            };
        },
    ],
    [
        'sortpubdate',
        function (_a) {
            var sortpubdate = _a.sortpubdate;
            return {
                issued: astrocite_core_1.parseDate(sortpubdate),
            };
        },
    ],
    [
        'source',
        function (_a) {
            var source = _a.source;
            return {
                journalAbbreviation: source,
                'container-title-short': source,
            };
        },
    ],
]);
var keys = Object.keys;
function parseEntry(entry) {
    if (schema_1.isError(entry)) {
        return new error_1.EUtilsError(entry.error, entry.uid);
    }
    return keys(entry).reduce(function (obj, key) {
        var _a, _b;
        if (!entry[key]) {
            return obj;
        }
        var transform = FIELD_TRANSFORMS.get(key);
        if (transform) {
            return __assign(__assign({}, obj), transform(entry));
        }
        var cslKey = constants_1.FIELD_MAP.get(key);
        if (cslKey) {
            return __assign(__assign({}, obj), (_a = {}, _a[cslKey] = entry[key], _a));
        }
        var htmlKey = constants_1.HTML_FIELD_MAP.get(key);
        if (htmlKey) {
            return __assign(__assign({}, obj), (_b = {}, _b[htmlKey] = he_1.decode(entry[key]), _b));
        }
        return obj;
    }, {
        id: entry.uid,
        type: 'article-journal',
    });
}
function toCSL(_a) {
    var error = _a.error, result = _a.result;
    return __spread((error ? [new error_1.EUtilsError(error, true)] : []), result.uids.map(function (id) { return parseEntry(result[id]); }));
}
exports.toCSL = toCSL;
